import {
  appAuthenticated,
  appLogout,
  appOpened,
  startListening,
} from '@betty/toolkit/state';
import { apiConfig } from '@betty/toolkit/api';
import { config } from '../config';

export const loadSmartico = () =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');

    script.src = 'https://libs.smartico.ai/smartico.js';

    script.onload = () => {
      if (window._smartico) {
        resolve(window._smartico);
      } else {
        reject(new Error('Smartico load error'));
      }
    };

    script.onerror = reject;

    document.body.appendChild(script);
  });

if (config) {
  startListening({
    actionCreator: appOpened,
    effect: async () => {
      await loadSmartico();

      window._smartico.init(config.labelKey, {
        brand_key: config.brandKey,
      });

      window._smartico_allow_localhost = true;

      const userId = await apiConfig.getUserId();

      if (!userId) {
        window._smartico_user_id = null;
        window._smartico_language = null;
      }
    },
  });

  startListening({
    actionCreator: appAuthenticated,
    effect: async () => {
      const userId = await apiConfig.getUserId();

      window._smartico_user_id = Number(userId);
      window._smartico_language = 'en';
    },
  });

  startListening({
    actionCreator: appLogout,
    effect: () => {
      window._smartico_user_id = null;
      window._smartico_language = null;
    },
  });
}
